import React from "react";
import {LiveGraphSubscriptionType} from "../../../../types/GraphSubscriptionType";

export type GraphSubscriptionListItemProps = {
    data: LiveGraphSubscriptionType[]
    index: number
    style: any
};

const GraphSubscriptionListItem = ({ data, index, style }: Readonly<GraphSubscriptionListItemProps>) => {

    if (index >= data.length) {
        return <div style={style}>Loading..</div>
    }

    const {
        id
    } = data[index];

    return (
        <div className="pb-2" style={style}>
            {id}
        </div>
    );
};

export default GraphSubscriptionListItem;